import { RewardProvider, CouponCodeItemStatus } from "../enums";

export interface CouponCodeDisplayDto {
  description: string;
  rewardProvider: RewardProvider;
  code: string;
  name: string;
  title: string;
  pictureUrl: string;
  availableUntil: string;
  status: CouponCodeItemStatus;
  info?: CouponCodeDisplayInfoDto[];
}

export interface CouponCodeDisplayInfoDto {
  title: string;
  items?: Record<string, string>;
}

export interface CouponValidateCodePostDto {
  code: string;
  rewardProvider: RewardProvider;
}
